module.exports = __webpack_public_path__ + "media/images/admin/icons/bell-off-8f086c05b71724f8490b82438973a86d.svg";